module.exports = __webpack_public_path__ + "img/logo-base.8c8df646.svg";